/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { compose } from 'recompose';
import { connect, useSelector, useDispatch } from 'react-redux';
import {
    object, string, func,
} from 'prop-types';
import loadable from '@loadable/component';
import { useLocation } from 'react-router';
import { getSSRDeviceType } from '../../../../state/ducks/App/App-Selectors';
import { getFeatureFlag } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import useUIDQueryConditionally from '../../../helpers/hooks/useUIDQueryConditionally';
import GenericSkeleton from '../../GraphqlComponents/GraphqlSkeletonComponents/GenericSkeleton';
import HeroSingleUI from './HeroSingleUI';

const HeroSingleResponsive = loadable(() => import(/* webpackChunkName: "HeroSingleResponsive" */  './HeroSingleResponsive'));
const HeroStory = loadable(() => import(/* webpackChunkName: "HeroStory" */  '../HeroStory/HeroStory'));
const HeroDepartment = loadable(() => import(/* webpackChunkName: "HeroDepartment" */  '../HeroDepartment/HeroDepartment'));
const HeroSingleV2 = loadable(() => import(/* webpackChunkName: "HeroSingle_V2" */  '../HeroSingle_V2/Responsive/HeroSingle_V2'));

const Hero = ({
    data: blockData, ssrDeviceType, salesforceResponse, setShowSkeleton, blockKey,
}) => {
    const { data, loading } = useUIDQueryConditionally({
        data: blockData,
        includeRefs: ['reference.message_collection.link_list.reference'],
        newDataSelector: (dta) => dta?.findContentByUID?.content?.entry || data,
    });
    const location = useLocation();
    const dispatch = useDispatch();
    useEffect(() => {
        setShowSkeleton(false);
    }, []);

    if (loading) {
        const mobileViewPort = ssrDeviceType.toLowerCase() === 'mobile';
        if (mobileViewPort && blockData?.mobile_skeleton) {
            return <GenericSkeleton height={blockData?.mobile_skeleton_height || blockData?.skeleton_height} />;
        }
        if (ssrDeviceType.toLowerCase() === 'desktop' && blockData?.desktop_skeleton) {
            return <GenericSkeleton height={blockData?.skeleton_height} />;
        }
    }

    if (!data) return <></>;
    if (data?.reference?.[0]?.['_content_type_uid'] === 'herosingle_v2') return <HeroSingleV2 data={data} />;
    if (data?.reference?.[0]?.['_content_type_uid'] === 'hero_story') return <HeroStory data={data} />;
    if (data?.reference?.[0]?.['_content_type_uid'] === 'hero_single_responsive') { return <HeroSingleResponsive data={data?.reference?.[0]} />; }
    if (data?.reference?.[0]?.['_content_type_uid'] === 'department_hero') return <HeroDepartment data={data} />;

    let block = null;
    if (data && !data?.reference?.[0]?.reference?.[0]) {
        block = data;
    } else if (data || data?.reference?.[0]?.reference?.[0]) {
        block = data.reference[0];
    }

    if (!block || !block?.reference?.[0]) {
        return null;
    }
    return (
        <HeroSingleUI
            salesforceResponse={salesforceResponse}
            block={block}
            data={data}
            isHeroRedesignEnabled={block?.presentation_type === 'Department V2'}
        />

    );
};

Hero.propTypes = {
    data: object.isRequired,
    ssrDeviceType: string.isRequired,
    salesforceResponse: object,
    setShowSkeleton: func,
    blockKey: string,
};
Hero.defaultProps = {
    salesforceResponse: {},
    setShowSkeleton: () => {},
    blockKey: '',
};
const mapStateToProps = (state) => ({
    ssrDeviceType: getSSRDeviceType(state),
});

const enhance = compose(
    connect(mapStateToProps, null),
);
export default enhance(Hero);
